// Eager callback route: the SDK handles the code before isLoading becomes false.
import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { AuthFailure } from './ProtectedRoute';

export function LoginPage() {
  const { isAuthenticated, isLoading, error, loginWithRedirect } = useAuth0();
  const [redirectFailed, setRedirectFailed] = useState(false);
  const redirectStarted = useRef(false);
  const params = new URLSearchParams(window.location.search);
  const callbackPresent = params.has('code') || params.has('error') || params.has('state');
  const signIn = () => {
    setRedirectFailed(false);
    void loginWithRedirect({ appState: { returnTo: '/accounts' } })
      .catch(() => setRedirectFailed(true));
  };
  useEffect(() => {
    if (isLoading || isAuthenticated || error || callbackPresent || redirectStarted.current) return;
    redirectStarted.current = true;
    void loginWithRedirect({ appState: { returnTo: '/accounts' } })
      .catch(() => setRedirectFailed(true));
  }, [isLoading, isAuthenticated, error, callbackPresent, loginWithRedirect]);

  if (error || redirectFailed || (!isLoading && !isAuthenticated && callbackPresent)) {
    return <AuthFailure onRetry={signIn} />;
  }
  if (!isLoading && isAuthenticated) return <Navigate to="/accounts" replace />;
  return <main className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
    <h1 tabIndex={-1} className="text-lg font-medium text-muted-foreground">Signing you in…</h1>
  </main>;
}
export default LoginPage;
